import { Typography } from '@mui/material'
import { useDispatch } from 'react-redux'
import { useEffect } from 'react'
import { actions, initialState } from '../../RestockingState'
import { useSelector } from 'src/utils/store'
import { isEqual } from 'lodash'
import FormSearchLists from '../../components/FormSearchRestockLists/FormSearchRestockLists'
import TableListManagement from '../../components/TableListManagement/TableListManagement'
import * as S from './RestockListManagement.styles'

const RestockListManagement = () => {
  const dispatch = useDispatch()
  const { filtersSearchLists, selectedFiltersHistory, autoFetchRestockingLists } = useSelector((state) => state.restocking)

  useEffect(() => {
    dispatch(actions.setRestockingLists({ restockingLists: initialState.restockingLists }))
  }, [dispatch])

  useEffect(() => {
    const hasNotFiltersSearchLists = isEqual(filtersSearchLists, initialState.filtersSearchLists)
    if (hasNotFiltersSearchLists) {
      dispatch(actions.getFiltersSearchLists)
    }
  }, [dispatch, filtersSearchLists])

  useEffect(() => {
    const hasHistorySelectedFilters = !isEqual(selectedFiltersHistory, initialState.selectedFiltersHistory)
    if (autoFetchRestockingLists && hasHistorySelectedFilters) {
      dispatch(actions.searchRestockingLists(selectedFiltersHistory))
    }
  }, [dispatch, autoFetchRestockingLists, selectedFiltersHistory])

  return (
    <S.Wrapper>
      <Typography variant='h5' fontWeight='bold'>Gerenciamento de listas</Typography>
      <FormSearchLists />
      <TableListManagement />
    </S.Wrapper>
  )
}

export default RestockListManagement
